'use strict';
import React, { PureComponent } from 'react';


class GrupoRadioButton extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { classLabel, onClick, nombre, valor } = this.props;

        return (
            <div className="Tarjetas-contenedorGrupoRadioButtonLabel" onClick={onClick ? () => onClick(nombre, valor) : null}>
                <div className="Tarjetas-contenedorRadioButton">
                    <div>
                        <div className={"AsientosContables--floatLeft " + (this.props.activo ? "Tarjetas-outsideRadioButtonActivo" : "Tarjetas-outsideRadioButtonInactivo")}></div>
                        <div className={"AsientosContables--floatLeft " + (this.props.activo ? "Tarjetas-insideRadioButton" : null)}></div>
                    </div>
                </div>
                
                <div className="Tarjetas-contenedorLabel">
                    <label className={"ABMModelosModalContainer__copiaRenglonlabel " + classLabel}>{this.props.label}</label>
                </div>
            </div>
        );
    }
}

export default GrupoRadioButton;